import { mapStateSortToDisplay } from "../../../../../../savedItemsSortConfig";

export const setSort = (state, { payload: { sort, sortOrder } }) => {
  const sortBy = mapStateSortToDisplay({ sort, sortOrder });
  const newState = {
    ...state,
    sortBy
  };

  return newState;
};
